import React, { useState, useEffect } from 'react'

import i18n from 'live/services/i18n';
import LiveSelect from 'live/components/forms/ui/select';
import { getExtensionsQualifier } from './api/google-integration';
import {MAP_HYBRID, MAP_LIGHT, MAP_ROAD } from 'plugin-extension-google/shared/GoogleMaps/LayersMenu';

const ConfigForm = ({ config = {sizePage: 0}, onChange }: any) => {    
    const [extensionsQualifiers, setExtensionsQualifiers] = useState();    
    const [selectedExtensionsQualifiers, setSelectedExtensionsQualifiers] = useState(config.extensionQualifier);

    useEffect(() => {
          getExtensionsQualifier().then(response => {        
          setExtensionsQualifiers(response.map(ele => ({ value: ele, label: ele })));
      });
    }, [])

    const handleChange = (key, value) => {
        onChange(key, value)
    }

    return (
       <>
          <div>
                <label>{i18n('Integração Google Maps')}</label>
                <LiveSelect
                    placeholder={i18n("Choose the integration")}
                    options={extensionsQualifiers}
                    value={selectedExtensionsQualifiers}
                    onChange={(value, obj) => {
                        handleChange('extensionQualifier', value)
                        setSelectedExtensionsQualifiers(obj);
                    }}
                />
          </div> 

          <div>
                <label>{i18n('Map type')}</label>
                <LiveSelect
                    placeholder={i18n("Choose the type")}
                    options={[
                        {value: MAP_HYBRID.id.toString(), label: MAP_HYBRID.title},
                        {value: MAP_LIGHT.id.toString(), label: MAP_LIGHT.title},
                        {value: MAP_ROAD.id.toString(), label: MAP_ROAD.title},
                    ]}
                    value={config.mapType}
                    onChange={(value, obj) => {
                        handleChange('mapType', value)
                    }}
                />
          </div> 

           <div>
              <label>Zoom</label>
              <input type="number" min={4} max={25} value={config.zoom} onChange={({ target }) => {
                    onChange('zoom', target.value)
              }}/>
          </div>       
       </>
    );
}

export default ConfigForm;
